import { useState } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import {
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../components/Iconify';
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import axios from '../../utils/axios';

export default function AIProfileConfirmDialog({ isOpen, closeDialog, reload }) {
  const smUp = useResponsive('up', 'sm');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const confirmAIProfile = async () => {
    try {
      setIsSubmitting(true);
      await axios.post(`/api/crews/ai/intro/accept/`);
      reload();
      setIsSubmitting(false);
      enqueueSnackbar('크루 소개 내용을 변경했습니다.', { variant: 'success' });
      closeDialog();
    } catch (err) {
      console.error(err);
      setIsSubmitting(false);
    }
  }

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} paragraph>
          AI가 작성한 크루 소개로 변경할까요?
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          소개를 바꾸면, 크루님이 작성했던 소개는 사라집니다. <br/>
          바꾸고 난 후에는 직접 수정할 수 있어요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <LoadingButton
          size="large"
          onClick={closeDialog}
          loading={isSubmitting}
        >
          취소
        </LoadingButton>
        <LoadingButton
          variant="contained"
          onClick={confirmAIProfile}
          size="large"
          sx={{ px: 3 }}
          loading={isSubmitting}
        >
          AI 크루 소개로 바꾸기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
};
